export default __webpack_public_path__ + "static/media/cBrdigeLight.9374de19.png";